export const BASE_URL="https://api.bintix.com/api/v1";
export const PORTAL_URL="https://portal.bintix.com";